<template>
    <div class="dateComponent">
      <ul class="dataSelect">
          <li v-for="(item,index) in dayMenu" :class="{'dayActive':dayFlag == index,'dayBtn':dayFlag !== index}" @click="daySelect(index)" :key="index">{{item.name}}</li>
      </ul>
      <div class="maskBackground" v-show="ifShowMask"></div>
      <div :class="{'dateSelect':!moveTop,'dateSelectTop':moveTop}" v-show="ifShowDate">
        <img class="closeBtn" @click="colseDateSelect" src="~common/image/closeBtn.png">
        <div class="titleDiv">
          <p class="dataTitle">选择日期范围</p>
          <p class="dataLimit">查询不超过12个月且不能跨年</p>
        </div>
        <div class="startDate">
          <div class="dateTitle">起始时间</div>
          <div class="startSelect" @click="selectTimeFn(1)">
            <span class="startText">{{this.startDate}}</span>
            <img class="turnRight" src="~common/image/turnRight.png">
          </div>
        </div>
        <div class="endDate">
          <div class="dateTitle">结束时间</div>
          <div class="endSelect" @click="selectTimeFn(2)">
            <span class="endText">{{this.endDate}}</span>
            <img class="turnRight" src="~common/image/turnRight.png">
          </div>
        </div>
        <div class="confimDiv">
          <div class="confimBtn" @click="searchFn()">查看</div>
        </div>
    </div>
    <mt-datetime-picker
      ref="picker"
      type="date"
      class="myPicker"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      v-model="pickerValue"
      confirmText="完成"
      cancelText=""
      @confirm="handleConfirm(1)"
      >
    </mt-datetime-picker>
  </div>
</template>
<script>
import { DatetimePicker } from 'mint-ui'
import { Toast } from 'mint-ui'
export default {
  data() {
    return {
      ifShowMask: false,
      ifShowDate: false,
      moveTop: false,
      pickerValue: new Date(),
      startDate: this.common.formatDate(new Date()),
      endDate: this.common.formatDate(new Date()),
      startDateFormat: new Date(),
      endDateFormat: new Date(),
      startOrEnd: '',
      dayMenu: this.dataTimeMenu,
      dayFlag: this.common.localGet('dayFlag')
    }
  },
  props: ['dataTimeMenu'],
  components: {
    DatetimePicker
  },
  methods: {
    daySelect(dayIndex) {
      this.dayFlag = dayIndex
      if (dayIndex === 0) {
        this.dayMenu[2].name = '自定义'  // 2018-03-05至2018-03-05
        this.$emit('select-date', [this.common.formatDate(new Date()), this.common.formatDate(new Date())])
        // this.getBusinessData(this.common.formatDate(new Date()), this.common.formatDate(new Date())) // 今天的时间
      }
      if (dayIndex === 1) {
        this.dayMenu[2].name = '自定义'  // 2018-03-05至2018-03-05
        // this.getBusinessData(this.common.formatDate(new Date() - 24 * 60 * 60 * 1000), this.common.formatDate(new Date() - 24 * 60 * 60 * 1000)) // 昨天的时间
        this.$emit('select-date', [this.common.formatDate(new Date() - 24 * 60 * 60 * 1000), this.common.formatDate(new Date() - 24 * 60 * 60 * 1000)])
      }
      if (dayIndex === 2) {
        this.ifShowMask = true
        this.ifShowDate = true
      }
    },
    colseDateSelect() {
      this.ifShowMask = false
      this.ifShowDate = false
      this.moveTop = false
      this.$refs.picker.close()
    },
    selectTimeFn(clickStyle) { // 1,点击的是开始时间 2,点击的是结束时间
      this.moveTop = true
      if (clickStyle === 1) {
        this.startOrEnd = 1
      } else if (clickStyle === 2) {
        this.handleConfirm(0)
        this.startOrEnd = 2
      }
      this.$refs.picker.open()
    },
    handleConfirm(topFlag) { // 完成 按钮
      if (topFlag === 0) {
        this.moveTop = true
      } else {
        this.moveTop = false
      }
      if (this.startOrEnd === 1) { // 开始时间的确定按钮
        this.startDateFormat = this.pickerValue  // 临时保存时间戳用于比较大小、跨年等
        this.startDate = this.common.formatDate(this.startDateFormat)
      } else if (this.startOrEnd === 2) {
        this.endDateFormat = this.pickerValue  // 临时保存时间戳用于比较大小、跨年等
        this.endDate = this.common.formatDate(this.endDateFormat)
      }
    },
    searchFn() { // 查看 按钮
      // this.startOrEnd = 2 // 点击查看，如果结束时间没有点击完成，则也会获取结束时间（对开始时间不起作用）
      if (this.startOrEnd === 2) {
        this.handleConfirm(1)
      }
      const startFirst = this.startDate.split('-')[0] // 截取年，用年做比较，两个年不一样，说明就跨年了
      const endFirst = this.endDate.split('-')[0]
      if (startFirst !== endFirst) {
        Toast({
          message: '时间选择不能跨年',
          duration: 3000
        })
        return
      }
      if (this.endDateFormat - this.startDateFormat < 0) {
        Toast({
          message: '结束时间不能小于开始时间！',
          duration: 3000
        })
        return
      }
      this.$emit('select-date', [this.startDate, this.endDate])
      // this.getBusinessData(this.startDate, this.endDate) // 自定义的时间
      const dataStr = this.startDate + ' 至 ' + this.endDate
      this.ifShowMask = false
      this.ifShowDate = false
      this.$refs.picker.close()
      this.dayMenu[2].name = dataStr  // 2018-03-05至2018-03-05
    }
  }
}
</script>
<style scoped>
  .dataSelect{
    width: 100%;
    height: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-color: yellow */
  }
  .dayActive{
    font-size: 0.24rem;  
    display: inline-block;
    background-color: #ffffff;
    color: #fc6063;
    border: 1px solid #ffffff;
    border-radius: 10px;
    padding: 0.04rem 0.2rem;
  }
  .dayBtn{
    font-size: 0.24rem;  
    display: inline-block;
    background-color: #CA494E;
    color: #ffffff;
    border: 1px solid #CA494E;
    border-radius: 10px;
    padding: 0.04rem 0.2rem;
  }
  .dayActive:nth-child(2),.dayBtn:nth-child(2){
    margin:0 0.2rem;
  }
  .startDate,.endDate{
    width: 100%;
    height: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:0 0.28rem;
    background-color: #ffffff;
    border-bottom: 1px solid #f1f2f3
  }
  .startSelect,.endSelect{
    width: 4rem;
    height: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .dateTitle{
    font-size: 0.32rem;
    color: #000000;
  }
  .startText,.endText{
    font-size: 0.32rem;
    color: #555555;
    margin-right: 0.15rem;
  }
  .maskBackground{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
    z-index: 200;
  }
  .dateSelect{
    width: 6.2rem;
    height: 4.8rem;
    position: relative;
    border-radius: 6px;
    position: fixed;
    top:10%;
    left: 50%;transform: translateX(-50%);
    background-color: #ffffff;
    z-index: 2100;
  }
  .dateSelectTop{
    width: 6.2rem;
    height: 4.8rem;
    position: relative;
    border-radius: 6px;
    position: fixed;
    top:1%;
    left: 50%;transform: translateX(-50%);
    background-color: #ffffff;
    z-index: 2100;
  }
  .closeBtn{
    position: absolute;
    right: 0.14rem;
    top: 0.14rem;
    width: 0.24rem;
    height: 0.24rem;
  }
  .titleDiv{
    width: 100%;
    height: 1.5rem;
    padding-top: 0.28rem;
    border-bottom: 1px solid #f1f2f3
  }
  .dataTitle{
    margin-bottom: 0.26rem;
    font-size: 0.32rem;
    color: #000000;
    font-weight: 600;
    text-align: center;
  }
  .dataLimit{
    font-size: 0.2rem;
    color: #555555;
    text-align: center;
  }
  .confimDiv{
    width:100%;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content:center;
  }
  .confimBtn{
    width: 3rem;
    height: 0.84rem;
    line-height: 0.84rem;
    text-align: center;
    background-color: #f74d47;
    color: #ffffff;
    font-size: 0.28rem;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dateSelect.vue